import { datajs, datajsAll, isBreakpointMdUp } from '../shared/utils';
import Plyr from 'plyr';

export default class HeroBlock {
	static init() {
		const heroBlocks = datajsAll('hero');

		if (!heroBlocks) {
			return;
		}

		heroBlocks.forEach((heroBlock) => {
			this.setupHeroBlock(heroBlock);
		});

		// Keep track of small/large video visibility breakpoint
		const breakpointMdUp = window.matchMedia(isBreakpointMdUp);
		breakpointMdUp.addEventListener('change', this.watchIsBreakpointMdUp);
	}

	// Handle play/pause between both videos in each block on window resize.
	static watchIsBreakpointMdUp(e) {
		const heroBlocks = datajsAll('hero');

		heroBlocks.forEach((heroBlock) => {
			const largeVideo = datajs('hero-video', heroBlock);
			const smallVideo = datajs('hero-video-small', heroBlock);

			// Check if the media query is true
			if (e.matches) {
				// Pause small video when screen resized to isBreakpointMdUp
				if (smallVideo) {
					smallVideo?.plyr.pause();
				}
			} else {
				// Pause large video when a small video exists and screen is resized below isBreakpointMdUp
				if (smallVideo && largeVideo) {
					largeVideo?.plyr.pause();
				}
			}
		});
	}

	static handleVideoEnded(e) {
		const videoInstance = e.detail.plyr;
		videoInstance.elements.container.closest('.o-hero')?.classList.add('o-hero--videoEnded');
		videoInstance.elements.container.closest('.o-hero')?.classList.remove('o-hero--videoEnabled');
		videoInstance.elements.container.closest('.o-hero')?.classList.remove('u-angles-none');

		if (document.fullscreenElement) {
			videoInstance.fullscreen.exit();
		}
	}

	// Setup Hero Block
	static setupHeroBlock(heroBlock) {
		const largeVideo = datajs('hero-video', heroBlock);
		const smallVideo = datajs('hero-video-small', heroBlock);
		const triggerBtn = datajsAll('trigger-video-mode', heroBlock);

		const playPauseVideos = function (firstVideo, secondVideo = false) {
			// Pause second video if it exists
			if (secondVideo) {
				secondVideo?.plyr.pause();
			}

			// Play first video if it exists
			if (firstVideo) {
				firstVideo?.plyr.play();
			}

			// If hero block has ended modifier class, remove it
			heroBlock.classList.remove('o-hero--videoEnded');
		};

		if (largeVideo) {
			this.videoConfig(largeVideo);
		}

		if (smallVideo) {
			this.videoConfig(smallVideo);
		}

		triggerBtn?.forEach((btn) => {
			btn.addEventListener('click', () => {
				window.requestAnimationFrame(() => {
					btn?.closest('.o-hero')?.classList.add('o-hero--videoEnabled');
					btn?.closest('.o-hero')?.classList.add('u-angles-none');
				});

				if (window.matchMedia(isBreakpointMdUp).matches) {
					playPauseVideos(largeVideo, smallVideo);
				} else {
					// If both a small and a large video exists:,
					if (smallVideo && largeVideo) {
						playPauseVideos(smallVideo, largeVideo);
					}

					// If only small video exists
					else if (smallVideo && !largeVideo) {
						playPauseVideos(smallVideo);
					}

					// If only largeVideo exists
					else if (largeVideo && !smallVideo) {
						playPauseVideos(largeVideo);
					}
				}
			});
		});
	}

	// Setup Video
	static videoConfig(
		video,
		config = {
			controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
		}
	) {
		const player = new Plyr(video, config);

		// Apply same classes to the Plyr wrapper as the initial video element
		if (player.media.classList.contains('d-md-none')) {
			player.elements.container.classList.add('d-md-none');
		}

		if (player.media.classList.contains('d-md-block')) {
			player.elements.container.classList.add('d-md-block');
		}

		if (player.media.classList.contains('d-none')) {
			player.elements.container.classList.add('d-none');
		}

		// Add event listeners to videos to determine when a video has ended
		player.on('ended', this.handleVideoEnded);
	}
}
